var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    transform: "rotate(-180 40 40)",
    stroke: "var(--a, #000)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.588V57.41M28.705 33.648L40 22.352l11.295 11.294",
    stroke: "var(--a, #000)"
  })));
}

export default SvgArrowUpCircle;